module.exports = __webpack_public_path__ + "assets/img/BnBerry-Landing-Page-+-Website-w540.7ee92e2d.webp";